import { View, Text, StyleSheet, TouchableOpacity, Alert, DeviceEventEmitter, ScrollView, Dimensions, Modal, Platform } from 'react-native'
import React, { useEffect, useState, memo } from 'react'
import { theme } from '../constants/theme';
import { Image } from 'react-native';
import { downloadFile, getSupabaseFileUrl, getUserImageSrc } from '../services/imageService';
import { hp, stripHtmlTags, wp } from '../helpers/common';
import moment from 'moment';
import RenderHtml from 'react-native-render-html';
import {Heart,Comment,Edit,Delete,ThreeDotsHorizontal} from '../../assets/icons';
import Video from 'react-native-video';
import { createPostLike, removePostLike } from '../services/postService';
import { getUserCommunityRole } from '../services/communityService';

import Loading from './Loading';
import Avatar from './Avatar';
import placeholderVideoImg from '../../assets/images/video-placeholder.png';
import { useNavigation } from '@react-navigation/native';
import FullScreenMedia from './FullScreenMedia';
import TextWithLinks from './TextWithLinks';

import defaultUserImg from '../../assets/images/defaultuser.png';

const textStyle = {
  color: theme.colors.dark,
  fontSize: hp(1.75)
}

const tagsStyles = {
  div: textStyle,
  p: textStyle,
  ol: textStyle,
  h1: {
    color: theme.colors.dark
  },
  h4: {
    color: theme.colors.dark
  },
};

const PostCard = memo(({
  item,
  currentUser,
  //router,
  showMoreIcon=true,
  hasShadow=true,
  showDelete=false,
  onDelete=()=>{},
  onEdit=()=>{},
  showReportSpam=true,
  allowLinks=false
}) => {
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [fullScreenMediaType, setFullScreenMediaType] = useState('image');
  const [isCommunityMember, setIsCommunityMember] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const navigation = useNavigation();

  const liked = likes.filter(like=> like.userId==currentUser?.id)[0]? true: false;
  const createdAt = moment(item?.created_at).format('MMM D');
  const htmlBody = { html: item?.body };
  const shadowStyles = {
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.06,
    shadowRadius: 6,
    elevation: 1,
  }
  // console.log('PostCard comments data:', item?.comments, 'type:', typeof item?.comments, 'length:', item?.comments?.length);

  useEffect(()=>{
    setLikes(item?.postLikes || []);
    checkCommunityMembership();
  },[]);

  // Watch for changes in item.postLikes to sync with real-time updates
  useEffect(() => {
    setLikes(item?.postLikes || []);
  }, [item?.postLikes]);

  const checkCommunityMembership = async () => {
    if (currentUser?.id && item?.community_id) {
      const result = await getUserCommunityRole(currentUser.id, item.community_id);
      setIsCommunityMember(result.success && result.data);
    } else {
      setIsCommunityMember(true); // If no community, allow editing (general posts)
    }
  };


  
  const onLike = async ()=>{

    if(!currentUser?.id) {
      Alert.alert('Error', 'You must be logged in to like posts');
      return;
    }

    if(liked){
      let updatedLikes = likes.filter(like=> like.userId!=currentUser.id);
      setLikes([...updatedLikes]);

      let res = await removePostLike(item?.id, currentUser.id);
      if(!res.success){
        Alert.alert('Post', 'Something went wrong!')
      }
    }else{
      let data = {
        userId: currentUser.id,
        postId: item?.id,
      }

      setLikes([...likes, data]);
      let res = await createPostLike(data);
      if(!res.success){
        Alert.alert('Post', 'Something went wrong!')
      }
    }
    
  }



  const handlePostDelete = () => {
    // Use a web-friendly confirmation, since Alert.alert is unreliable on web
    if (Platform.OS === 'web') {
      try {
        const confirmed = window.confirm
          ? window.confirm('Are you sure you want to delete this post?')
          : true; // Fallback: assume confirmed if confirm is not available
        if (confirmed) {
          onDelete(item);
        }
      } catch (e) {
        // If anything goes wrong, still attempt delete
        onDelete(item);
      }
      return;
    }

    // Native platforms: use standard Alert.confirm dialog
    Alert.alert('Confirm', 'Are you sure you want to do this?', [
      {
        text: 'Cancel',
        onPress: () => {},
        style: 'cancel',
      },
      {
        text: 'Delete',
        onPress: () => onDelete(item),
        style: 'destructive',
      },
    ]);
  }

  const openPostDetails = ()=>{
    try {
      if (item?.id) {
        // Ensure postId is passed as a number (database uses bigint)
        const postId = typeof item.id === 'string' ? parseInt(item.id, 10) : item.id;
        if (isNaN(postId)) {
          console.warn('PostCard: Invalid post ID format:', item.id);
          return;
        }
        navigation.navigate('postDetails', { postId });
      } else {
        console.warn('PostCard: Cannot navigate - post ID is missing');
      }
    } catch (error) {
      console.error('PostCard: Navigation error:', error);
    }
  }



  const handleMoreOptions = () => {
    // On web, use modal instead of Alert
    if (Platform.OS === 'web') {
      setShowOptionsModal(true);
    } else {
      // On native, use Alert
      const isAnnouncement = item?.is_announcement === true;
      
      const options = [
        ...(isAnnouncement || !showReportSpam ? [] : [{ text: 'Report Spam', style: 'destructive', onPress: () => navigation.navigate('ReportPost', { postId: item?.id }) }]),
        { text: 'View Details', onPress: openPostDetails },
        { text: 'Cancel', style: 'cancel' },
      ];
      
      Alert.alert('Post Options', undefined, options);
    }
  }

  const handleOptionPress = (action) => {
    setShowOptionsModal(false);
    
    if (action === 'viewDetails') {
      openPostDetails();
    } else if (action === 'reportSpam') {
      navigation.navigate('ReportPost', { postId: item?.id });
    }
  }

  // Parse file field - can be string (single) or array (multiple images)
  const normalizePathArray = (list) => {
    if (!Array.isArray(list)) return [];
    return list
      .map((entry) => {
        if (typeof entry === 'string') return entry.trim();
        if (entry && typeof entry === 'object' && typeof entry.file === 'string') return entry.file.trim();
        return '';
      })
      .filter(Boolean);
  };

  const parseFileField = () => {
    if (!item?.file) return { type: 'none', files: [] };
    
    // If it's an array, it's multiple images
    if (Array.isArray(item.file)) {
      return { type: 'gallery', files: normalizePathArray(item.file) };
    }
    
    // If it's a string, check if it's video or image
    if (typeof item.file === 'string') {
      const trimmed = item.file.trim();

      // Try parsing JSON for stored arrays or objects
      if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return { type: 'gallery', files: normalizePathArray(parsed) };
          }
          if (parsed && Array.isArray(parsed.files)) {
            return { type: 'gallery', files: normalizePathArray(parsed.files) };
          }
        } catch (error) {
          console.warn('Failed to parse file field JSON:', error);
        }
      }

      if (item.file.includes('postVideos')) {
        return { type: 'video', files: [item.file] };
      }
      return { type: 'image', files: [item.file] };
    }
    
    return { type: 'none', files: [] };
  };

  const mediaInfo = parseFileField();
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);

  useEffect(() => {
    setSelectedMediaIndex(0);
  }, [item?.file]);

  const openFullScreenMedia = (mediaType, mediaUrl = null, index = 0) => {
    setFullScreenMediaType(mediaType);
    setSelectedMediaIndex(index);
    setShowFullScreen(true);
  };

  const closeFullScreenMedia = () => {
    setShowFullScreen(false);
  };

  const getCurrentMediaUrl = () => {
    if (mediaInfo.type === 'gallery' && mediaInfo.files.length > 0) {
      return mediaInfo.files[selectedMediaIndex] || mediaInfo.files[0];
    }
    return mediaInfo.files[0] || item?.file;
  };

  const navigateToUserProfile = () => {
    if (item?.user?.id) {
      navigation.navigate('profile', { userId: item.user.id });
    }
  };

  const isPinned = item?.is_pinned === true;

  // No video auto-pause needed - videos open in fullscreen

  // No video pause needed - videos open in fullscreen

  return (
    <View style={[styles.container, hasShadow && shadowStyles, isPinned && styles.pinnedContainer]} renderToHardwareTextureAndroid shouldRasterizeIOS>
      <View style={styles.header}>
        {/* user info and post time */}
        <View style={styles.userInfo}>
          <TouchableOpacity onPress={navigateToUserProfile} activeOpacity={0.7}>
            <Avatar 
              size={hp(4.5)}
              uri={item?.user?.image}
              rounded={theme.radius.md}
            />
          </TouchableOpacity>
          <View style={{gap: 2}}>
            <View style={styles.usernameRow}>
              <Text style={styles.username}>{item?.user?.name || item?.user_id || 'Unknown User'}</Text>
              {isPinned && (
                <View style={styles.pinIndicator}>
                  <Text style={styles.pinIcon}>📌</Text>
                  <Text style={styles.pinText}>Pinned</Text>
                </View>
              )}
            </View>
            {item?.community?.name && (
              <TouchableOpacity
                activeOpacity={0.7}
                onPress={() => {
                  const communityId = item?.community_id || item?.community?.id;
                  if (communityId) {
                    navigation.navigate('CommunityDetails', {
                      communityId,
                      profileImage: item?.community?.profile_image || null,
                    });
                  }
                }}
              >
                <Text style={{ fontSize: hp(1.6), color: theme.colors.primary, fontWeight: 'bold' }}>in {item.community.name}</Text>
              </TouchableOpacity>
            )}
            <Text style={styles.postTime}>{createdAt}</Text>
            {item?.is_deal && (
              <View style={styles.dealBadge}>
                <Text style={styles.dealBadgeGlow}>✨</Text>
                <Text style={styles.dealBadgeText}>SPECIAL OFFER</Text>
                <Text style={styles.dealBadgeGlow}>✨</Text>
              </View>
            )}
          </View>
        </View>

        {/* actions */}
        {
          showMoreIcon && (
            <TouchableOpacity onPress={handleMoreOptions}>
              <ThreeDotsHorizontal size={hp(3.4)} strokeWidth={3} color={theme.colors.text} />
            </TouchableOpacity>
          )
        }
        {
          showDelete && currentUser?.id==item.userId && isCommunityMember && (
            <View style={styles.actions}>
              <TouchableOpacity onPress={()=> onEdit(item)}>
                <Edit size={hp(2.5)} color={theme.colors.text} />
              </TouchableOpacity>
              <TouchableOpacity onPress={handlePostDelete}>
                <Delete size={hp(2.5)} color={theme.colors.rose} />
              </TouchableOpacity>
            </View>
          )
        }
      </View>

      {/* post image & body */}
      <View style={styles.content}>
        <View style={styles.postBody}>
          {
            item?.body && (
              /<|>/.test(item.body)
                ? (
                  <RenderHtml
                    contentWidth={wp(100)}
                    source={htmlBody}
                    tagsStyles={tagsStyles}
                  />
                )
                : (
                  (() => {
                    const shouldRenderLinks = Boolean(allowLinks);
                    if (shouldRenderLinks) {
                      return (
                        <TextWithLinks
                          text={item.body}
                          textStyle={textStyle}
                          linkStyle={{ ...textStyle, color: theme.colors.primary, textDecorationLine: 'underline' }}
                        />
                      );
                    } else {
                      return <Text style={textStyle}>{item.body}</Text>;
                    }
                  })()
                )
            )
          }
        </View>
        
        {/* Multiple images gallery */}
        {mediaInfo.type === 'gallery' && mediaInfo.files.length > 0 && (
          <View style={styles.galleryWrapper}>
            <ScrollView
              horizontal
              pagingEnabled
              showsHorizontalScrollIndicator={false}
              style={styles.galleryContainer}
              onMomentumScrollEnd={(event) => {
                const index = Math.round(event.nativeEvent.contentOffset.x / event.nativeEvent.layoutMeasurement.width);
                setSelectedMediaIndex(index);
              }}
            >
              {mediaInfo.files.map((filePath, index) => {
                const imgSource = getSupabaseFileUrl(filePath) || defaultUserImg;
                // Lazy load: Only load first image immediately, others load when visible
                // For web, we can use loading="lazy" but React Native Image doesn't support it
                // Instead, we'll only render images that are close to the current view
                const shouldLoad = index === 0 || Math.abs(index - selectedMediaIndex) <= 1;
                
                return (
                  <TouchableOpacity
                    key={index}
                    onPress={() => openFullScreenMedia('image', filePath, index)}
                    activeOpacity={0.9}
                    style={styles.galleryImageContainer}
                  >
                  {shouldLoad ? (
                    <Image 
                      source={imgSource}
                      transition={100}
                      style={styles.postMedia}
                      contentFit='cover'
                      // @ts-ignore - loading prop for web lazy loading
                      loading={index === 0 ? 'eager' : 'lazy'}
                    />
                  ) : (
                    // Placeholder for unloaded images
                    <View style={[styles.postMedia, { backgroundColor: '#f0f0f0', justifyContent: 'center', alignItems: 'center' }]}>
                      <Text style={{ color: '#999' }}>Loading...</Text>
                    </View>
                  )}
                </TouchableOpacity>
              );
              })}
            </ScrollView>
            {mediaInfo.files.length > 1 && (
              <View style={styles.galleryCounter}>
                <Text style={styles.galleryCounterText}>
                  {selectedMediaIndex + 1}/{mediaInfo.files.length}
                </Text>
              </View>
            )}
          </View>
        )}
        
        {/* Single image */}
        {mediaInfo.type === 'image' && mediaInfo.files.length > 0 && (
          <TouchableOpacity onPress={() => openFullScreenMedia('image', mediaInfo.files[0], 0)} activeOpacity={0.9}>
            <Image 
              source={getSupabaseFileUrl(mediaInfo.files[0]) || defaultUserImg}
              transition={100}
              style={styles.postMedia}
              contentFit='cover'
              // @ts-ignore - loading prop for web lazy loading
              loading="lazy"
            />
          </TouchableOpacity>
        )}
        
        {/* Video */}
        {mediaInfo.type === 'video' && mediaInfo.files.length > 0 && (
            <TouchableOpacity 
            onPress={() => openFullScreenMedia('video', mediaInfo.files[0], 0)}
              style={{ position: 'relative', width: '100%', height: hp(40), borderRadius: theme.radius.xl, overflow: 'hidden' }}
              activeOpacity={0.9}
            >
              <Image
                source={ item?.thumbnail ? getSupabaseFileUrl(item.thumbnail) : placeholderVideoImg }
                style={[styles.postMedia, { position: 'absolute', width: '100%', height: '100%' }]}
                resizeMode='cover'
                // @ts-ignore - loading prop for web lazy loading
                loading="lazy"
              />
              <View style={{ position: 'absolute', top: '45%', left: '45%', zIndex: 2, backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: 30, padding: 10 }}>
                <Text style={{ color: 'white', fontSize: 18 }}>▶</Text>
              </View>
              <View style={{ position: 'absolute', top: 10, right: 10, zIndex: 2, backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: 5, padding: 5 }}>
                <Text style={{ color: 'white', fontSize: 12 }}>⛶</Text>
              </View>
            </TouchableOpacity>
        )}
      </View>

      {/* like & comment */}
      <View style={styles.footer}>
        <View style={styles.footerButton}>
          <TouchableOpacity onPress={onLike}>
            <Heart fill={liked? theme.colors.rose: 'transparent'} size={24} color={liked? theme.colors.rose: theme.colors.textLight} />
          </TouchableOpacity>
          <Text style={styles.count}>
            {
              likes?.length
            }
          </Text>
        </View>
        <View style={styles.footerButton}>
          <TouchableOpacity onPress={openPostDetails}>
            <Comment size={24} color={theme.colors.textLight} />
          </TouchableOpacity>
          <Text style={styles.count}>
            {/* implement after adding post details modal */}
            {/* 0 */}
            {(() => {
              // Handle different comment data structures
              let count = 0;
              
              if (item?.comments && Array.isArray(item.comments)) {
                if (item.comments.length > 0 && item.comments[0]?.count !== undefined) {
                  // Format: [{count: number}]
                  count = item.comments[0].count;
                } else {
                  // Format: array of comment objects
                  count = item.comments.length;
                }
              }
              
              return count;
            })()}
          </Text>
        </View>

      </View>

      {/* Full Screen Media Modal */}
      {getCurrentMediaUrl() && (
        <FullScreenMedia
          visible={showFullScreen}
          onClose={closeFullScreenMedia}
          mediaUrl={getCurrentMediaUrl()}
          mediaType={fullScreenMediaType}
          title={`Post by ${item.user?.name || 'User'}`}
        />
      )}

      {/* Options Modal for Web */}
      {Platform.OS === 'web' && (
        <Modal
          visible={showOptionsModal}
          transparent
          animationType="fade"
          onRequestClose={() => setShowOptionsModal(false)}
        >
          <TouchableOpacity
            style={styles.modalOverlay}
            activeOpacity={1}
            onPress={() => setShowOptionsModal(false)}
          >
            <View style={styles.modalContent}>
              <TouchableOpacity
                style={styles.modalOption}
                onPress={() => handleOptionPress('viewDetails')}
              >
                <Text style={styles.modalOptionText}>View Details</Text>
              </TouchableOpacity>
              {!item?.is_announcement && showReportSpam && (
                <TouchableOpacity
                  style={[styles.modalOption, styles.modalOptionDestructive]}
                  onPress={() => handleOptionPress('reportSpam')}
                >
                  <Text style={[styles.modalOptionText, styles.modalOptionTextDestructive]}>Report Spam</Text>
                </TouchableOpacity>
              )}
              <TouchableOpacity
                style={styles.modalOption}
                onPress={() => setShowOptionsModal(false)}
              >
                <Text style={styles.modalOptionText}>Cancel</Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </Modal>
      )}
    </View>
  )
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary re-renders
  return (
    prevProps.item?.id === nextProps.item?.id &&
    prevProps.item?.body === nextProps.item?.body &&
    prevProps.item?.file === nextProps.item?.file &&
    prevProps.item?.created_at === nextProps.item?.created_at &&
    prevProps.item?.userId === nextProps.item?.userId &&
    JSON.stringify(prevProps.item?.postLikes) === JSON.stringify(nextProps.item?.postLikes) &&
    JSON.stringify(prevProps.item?.comments) === JSON.stringify(nextProps.item?.comments) &&
    prevProps.currentUser?.id === nextProps.currentUser?.id &&
    prevProps.showMoreIcon === nextProps.showMoreIcon &&
    prevProps.hasShadow === nextProps.hasShadow &&
    prevProps.showDelete === nextProps.showDelete &&
    prevProps.showReportSpam === nextProps.showReportSpam
  );
})

const styles = StyleSheet.create({
  container: {
    gap: 10,
    marginBottom: 15,
    borderRadius: theme.radius.xxl*1.1,
    borderCurve: 'continuous',
    padding: 10,
    paddingVertical: 12,
    backgroundColor: 'white',
    borderWidth: 0.5,
    borderColor: theme.colors.gray,
    shadowColor: '#000'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },  
  username: {
    fontSize: hp(1.7),
    color: theme.colors.textDark,
    fontWeight: theme.fonts.medium,
  },
  postTime: {
    fontSize: hp(1.4),
    color: theme.colors.textLight,
    fontWeight: theme.fonts.medium,
  },
  content: {
    gap: 10,
    // marginBottom: 10,
  },
  postMedia: {
    height: hp(40),
    width: '100%',
    borderRadius: theme.radius.xl,
    // borderCurve: 'continuous' // Removed for Image compatibility
  },
  galleryWrapper: {
    position: 'relative',
    height: hp(40),
    borderRadius: theme.radius.xl,
    overflow: 'hidden',
  },
  galleryContainer: {
    height: hp(40),
  },
  galleryImageContainer: {
    width: Dimensions.get('window').width - wp(8), // Screen width minus horizontal padding
    height: hp(40),
  },
  galleryCounter: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 15,
  },
  galleryCounterText: {
    color: 'white',
    fontSize: hp(1.5),
    fontWeight: '600',
  },
  dealBadge: {
    marginTop: 6,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ff6b6b',
    paddingHorizontal: 18,
    paddingVertical: 10,
    borderRadius: 25,
    shadowColor: '#ff6b6b',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.6,
    shadowRadius: 10,
    elevation: 8,
    gap: 8,
    borderWidth: 2,
    borderColor: '#ffffff',
    transform: [{ scale: 1.05 }],
  },
  dealBadgeText: {
    color: '#ffffff',
    fontSize: hp(1.6),
    fontWeight: '900',
    letterSpacing: 2,
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 3,
  },
  dealBadgeGlow: {
    fontSize: hp(2),
    textShadowColor: 'rgba(255, 255, 255, 0.8)',
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 4,
  },
  postBody: {
    marginLeft: 5,
  },
  footer: {
    flexDirection: 'row', 
    alignItems: 'center',
    gap: 15
  },
  footerButton: {
    marginLeft: 5,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center', 
    gap: 18,
  },
  count: {
    color: theme.colors.text,
    fontSize: hp(1.8)
  },
  pinnedContainer: {
    borderLeftWidth: 4,
    borderLeftColor: theme.colors.primary,
    backgroundColor: theme.colors.backgroundLight,
  },
  usernameRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  pinIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.primary,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 12,
    gap: 4,
  },
  pinIcon: {
    fontSize: hp(1.2),
  },
  pinText: {
    fontSize: hp(1.2),
    color: 'white',
    fontWeight: '600',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: theme.radius.lg,
    padding: 0,
    minWidth: 200,
    maxWidth: 300,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalOption: {
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.gray,
  },
  modalOptionDestructive: {
    borderBottomWidth: 0,
  },
  modalOptionText: {
    fontSize: hp(1.8),
    color: theme.colors.text,
    textAlign: 'center',
  },
  modalOptionTextDestructive: {
    color: theme.colors.rose || '#ef4444',
  },

})

export default PostCard